import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';

export interface BillingSummary {
  total_paid_cents: number;
  invoice_count: number;
  last_payment_date: string | null;
  open_invoice_count: number;
}

export function useBillingSummary(userId: string) {
  return useQuery({
    queryKey: ['user-billing-summary', userId],
    queryFn: () => apiClient<BillingSummary>(`/users/${userId}/billing-summary`),
  });
}

export interface Transaction {
  source_type: 'invoice' | 'charge';
  id: number;
  stripe_id: string | null;
  invoice_number: string | null;
  status: string;
  amount_due: number | string | null;
  amount_paid: number | string | null;
  currency: string | null;
  created_date: string;
  paid_at: string | null;
  link_url: string | null;
  pdf_url: string | null;
  failure_message: string | null;
}

export interface PaymentsResponse {
  transactions: Transaction[];
  summary: {
    totalPaid: number;
    successCount: number;
    failedCount: number;
    pendingCount: number;
    totalTransactions: number;
  };
}

export function useUserPayments(userId: string) {
  return useQuery({
    queryKey: ['user-payments', userId],
    queryFn: () => apiClient<PaymentsResponse>(`/users/${userId}/payments`),
  });
}
